import { LOGOS } from '../../data/customerLogos';

/* Logo wall. Uses the same real customers as the strip higher up the page —
   it previously showed invented brands (Meridian, NovaCart, HELIXPAY…), and
   those wordmarks broke outright when their CSS was removed with the strip
   rebuild, leaving six blank tiles.

   Five real logos in a six-cell grid, with the last cell carrying the rest of
   the count so the grid stays even and the claim stays honest. */

export default function Power() {
  return (
    <section className="sect" id="s-power" style={{ paddingTop: '24px' }}>
      <div className="power">
        <div className="power-grid">
          <div>
            <div className="pl">PATTERN POWERHOUSE</div>
            <h2>Powering teams<br />of all sizes</h2>
            <div className="power-stats">
              <div className="pstat">
                <div className="pv">500+</div>
                <div className="pd">active teams run on TeamGrid</div>
              </div>
              <div className="pstat">
                <div className="pv">12M+</div>
                <div className="pd">work hours analysed</div>
              </div>
            </div>
          </div>

          <div className="logowall">
            {LOGOS.map((l) => (
              <div className="lw" key={l.alt}>
                <img src={l.src} alt={l.alt} loading="lazy" />
              </div>
            ))}
            <div className="lw lw-more">
              <span className="lwm-n">+495</span>
              <span className="lwm-t">more teams</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
